// dateUtils.js (example utility file)
export const formatPostDate = (dateString) => {
    if (!dateString) {
      return "No Date";
    }
  
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) {
      return "No Date";
    }
  
    // Example: Jan 31
    const datePart = dateObj.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  
    // 4-digit year, e.g., 2023
    const year = dateObj.getFullYear();
  
    // Example: 5:26 AM
    let timePart = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  
    // Convert AM/PM to lowercase am/pm
    timePart = timePart.replace("AM", "am").replace("PM", "pm");
  
    // Combine into final format => "Posted Jan 31, 2023 5:26 am"
    return `Posted ${datePart}, ${year} ${timePart}`;
  };
  